export function resolveVideoSourceFromContent(content) {
  if (!content) return "link";
  if (content.OrigemVideo === "Upload" || content.UrlArquivo) return "upload";
  if (content.UrlExterna || content.OrigemVideo === "Externo") return "link";
  return "link";
}

export function getVideoEmbedUrl(url) {
  if (!url?.trim()) return "";

  const value = url.trim();

  const youtubeWatch = value.match(
    /(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/i,
  );
  if (youtubeWatch?.[1]) {
    return `https://www.youtube.com/embed/${youtubeWatch[1]}`;
  }

  const vimeo = value.match(/vimeo\.com\/(?:video\/)?(\d+)/i);
  if (vimeo?.[1]) {
    return `https://player.vimeo.com/video/${vimeo[1]}`;
  }

  if (value.includes("/embed/") || value.includes("player.vimeo.com")) {
    return value;
  }

  return value;
}

export function isEmbeddableVideoUrl(url) {
  if (!url?.trim()) return false;
  return /youtube|youtu\.be|vimeo|embed/i.test(url);
}
